import { render } from "./B2bTableMenuAuditoriaAcciones.vue?vue&type=template&id=2e18a70c&scoped=true&lang=pug"
import script from "./B2bTableMenuAuditoriaAcciones.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuAuditoriaAcciones.vue?vue&type=script&lang=js"

import "./B2bTableMenuAuditoriaAcciones.vue?vue&type=style&index=0&id=2e18a70c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e18a70c"]])

export default __exports__